export const MIDDLEWARE_IP = 'https://mid.panel.korbank.pl';
